import { render, staticRenderFns } from "./LayoutsPhotosSection.vue?vue&type=template&id=1b3ec0a7"
import script from "./LayoutsPhotosSection.vue?vue&type=script&lang=ts"
export * from "./LayoutsPhotosSection.vue?vue&type=script&lang=ts"
import style0 from "./LayoutsPhotosSection.vue?vue&type=style&index=0&id=1b3ec0a7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports